export const API_GET_SITE_CONTEXT = `api/GET_SITE_CONTEXT`;
export const API_GET_SITE_CONTEXT_SUCCESS = `${API_GET_SITE_CONTEXT} [success]`;
export const API_GET_SITE_CONTEXT_FAIL = `${API_GET_SITE_CONTEXT} [fail]`;

export const API_GET_EARLY_REPAYMENT_SIMULATION = `api/GET_EARLY_REPAYMENT_SIMULATION`;
export const API_GET_EARLY_REPAYMENT_SIMULATION_SUCCESS = `${API_GET_EARLY_REPAYMENT_SIMULATION} [success]`;

export const API_GET_LOAN_DOCUMENTS = `api/GET_LOAN_DOCUMENTS`;
export const API_GET_LOAN_DOCUMENTS_SUCCESS = `${API_GET_LOAN_DOCUMENTS} [success]`;

export const API_POST_FUNDING_REQUEST = `api/POST_FUNDING_REQUEST`;
export const API_POST_FUNDING_REQUEST_SUCCESS = `${API_POST_FUNDING_REQUEST} [success]`;
export const API_POST_FUNDING_REQUEST_FAIL = `${API_POST_FUNDING_REQUEST} [fail]`;

export const API_GET_ACCOUNT_STATEMENT = `api/GET_ACCOUNT_STATEMENT`;
export const API_GET_ACCOUNT_STATEMENT_SUCCESS = `${API_GET_ACCOUNT_STATEMENT} [success]`;

export const API_GET_DOCUMENT_UPLOAD = `api/GET_DOCUMENT_UPLOAD`;
export const API_GET_DOCUMENT_UPLOAD_SUCCESS = `${API_GET_DOCUMENT_UPLOAD} [success]`;

export const API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD = `api/GET_ACCOUNT_STATEMENT_TO_DOWNLOAD`;
export const API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD_PENDING = `${API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD} [pending]`;
export const API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD_SUCCESS = `${API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD} [success]`;

export const API_GET_DOCUMENT_TO_SIGN = `api/GET_DOCUMENT_TO_SIGN`;
export const API_GET_DOCUMENT_TO_SIGN_SUCCESS = `${API_GET_DOCUMENT_TO_SIGN} [success]`;
export const API_GET_DOCUMENT_TO_SIGN_FAIL = `${API_GET_DOCUMENT_TO_SIGN} [fail]`;

export const API_GET_SIGNED_DOCUMENT = `api/GET_SIGNED_DOCUMENT`;
export const API_GET_SIGNED_DOCUMENT_SUCCESS = `${API_GET_SIGNED_DOCUMENT} [success]`;

export const API_PUT_AGREE_CUSTOMER_DOCUMENT = `api/PUT_AGREE_CUSTOMER_DOCUMENT`;
export const API_PUT_AGREE_CUSTOMER_DOCUMENT_SUCCESS = `${API_PUT_AGREE_CUSTOMER_DOCUMENT} [success]`;
export const API_PUT_AGREE_CUSTOMER_DOCUMENT_FAIL = `${API_PUT_AGREE_CUSTOMER_DOCUMENT} [fail]`;

export const API_GET_URL_FILE_TO_DOWNLOAD = `api/GET_URL_FILE_TO_DOWNLOAD`;
export const API_GET_URL_FILE_TO_DOWNLOAD_SUCCESS = `${API_GET_URL_FILE_TO_DOWNLOAD} [success]`;

export const API_GET_CUSTOMER_STATE = `api/GET_CUSTOMER_STATE`;
export const API_GET_CUSTOMER_STATE_SUCCESS = `${API_GET_CUSTOMER_STATE} [success]`;
export const API_GET_CUSTOMER_STATE_EDIT = `${API_GET_CUSTOMER_STATE} [edit]`;

export const API_SAVE_CUSTOMER_STATE = `api/SAVE_CUSTOMER_STATE`;
export const API_SAVE_CUSTOMER_STATE_SUCCESS = `${API_SAVE_CUSTOMER_STATE} [success]`;
export const API_SAVE_CUSTOMER_STATE_FAIL = `${API_SAVE_CUSTOMER_STATE} [fail]`;

export const API_PUT_CUSTOMER_STATE = `api/PUT_CUSTOMER_STATE`;
export const API_PUT_CUSTOMER_STATE_SUCCESS = `${API_PUT_CUSTOMER_STATE} [success]`;
export const API_PUT_CUSTOMER_STATE_FAIL = `${API_PUT_CUSTOMER_STATE} [fail]`;

export const API_GET_PAYMENT_METHOD = `api/GET_PAYMENT_METHOD`;
export const API_GET_PAYMENT_METHOD_SUCCESS = `${API_GET_PAYMENT_METHOD} [success]`;

export const API_PUT_PAYMENT_METHOD = `api/PUT_PAYMENT_METHOD`;
export const API_PUT_PAYMENT_METHOD_SUCCESS = `${API_PUT_PAYMENT_METHOD} [success]`;

export const API_POST_PAYMENT_METHOD = `api/POST_PAYMENT_METHOD`;

export const API_DELETE_PAYMENT_METHOD = `api/DELETE_PAYMENT_METHOD`;
export const API_DELETE_PAYMENT_METHOD_SUCCESS = `${API_DELETE_PAYMENT_METHOD} [success]`;

export const API_GET_FUNDING_REQUIREMENT = `api/GET_FUNDING_REQUIREMENT`;
export const API_GET_FUNDING_REQUIREMENT_SUCCESS = `${API_GET_FUNDING_REQUIREMENT} [success]`;

export const API_GET_PRODUCT_OFFERS = `api/GET_PRODUCT_OFFERS`;

export const API_GET_ADDRESS_LOOKUP = `api/GET_ADDRESS_LOOKUP`;
export const API_GET_ADDRESS_LOOKUP_SUCCESS = `${API_GET_ADDRESS_LOOKUP} [success]`;

export const API_GET_COMPANY_LOOKUP = `api/GET_COMPANY_LOOKUP`;
export const API_GET_COMPANY_LOOKUP_PENDING = `${API_GET_COMPANY_LOOKUP} [pending]`;
export const API_GET_COMPANY_LOOKUP_SUCCESS = `${API_GET_COMPANY_LOOKUP} [success]`;

export const API_GET_ONLINE_ACCOUNT = `api/GET_ONLINE_ACCOUNT`;
export const API_GET_ONLINE_ACCOUNT_SUCCESS = `${API_GET_ONLINE_ACCOUNT} [success]`;

export const API_DELETE_ONLINE_ACCOUNT = `api/DELETE_ONLINE_ACCOUNT`;
export const API_DELETE_ONLINE_ACCOUNT_SUCCESS = `${API_DELETE_ONLINE_ACCOUNT} [success]`;
export const API_DELETE_ONLINE_ACCOUNT_FAIL = `${API_DELETE_ONLINE_ACCOUNT} [fail]`;

export const API_POST_ONFIDO_SMS = `api/POST_ONFIDO_SMS`;
export const API_POST_ONFIDO_SMS_SUCCESS = `${API_POST_ONFIDO_SMS} [success]`;
export const API_POST_ONFIDO_SMS_FAIL = `${API_POST_ONFIDO_SMS} [fail]`;

export const API_GET_APPLICATION = `api/GET_APPLICATION`;
export const API_GET_APPLICATION_SUCCESS = `api/GET_APPLICATION [success]`;

export const API_PUT_APPLICATION = `api/PUT_APPLICATION`;

export const API_GET_FORMAL_OFFERS = `api/GET_FORMAL_OFFERS`;

export const API_POST_FORMAL_OFFERS = `api/POST_FORMAL_OFFERS`;

export const API_POST_DECLINE_APPLICATION = `api/POST_DECLINE_APPLICATION`;

export const API_GET_ACCOUNTS = `api/GET_ACCOUNTS`;
export const API_GET_ACCOUNTS_SUCCESS = `${API_GET_ACCOUNTS} [success]`;

export const API_POST_THREATMETRIX = `api/POST_THREATMETRIX`;

export const API_PUT_THREATMETRIX = `api/PUT_THREATMETRIX`;

export const API_GET_RBL_ESTIMATED_SCHEDULE = 'api/GET_RBL_ESTIMATED_SCHEDULE';
export const API_GET_RBL_ESTIMATED_SCHEDULE_SUCCESS = `${API_GET_RBL_ESTIMATED_SCHEDULE} [success]`;

export const API_GET_OFFER_CONFIGURATION = 'api/GET_OFFER_CONFIGURATION';

export const API_POST_FUND_PRODUCT_OFFER_REQUEST =
    'api/POST_FUND_PRODUCT_OFFER_REQUEST';
export const API_POST_FUND_PRODUCT_OFFER_REQUEST_SUCCESS = `${API_POST_FUND_PRODUCT_OFFER_REQUEST} [success]`;
export const API_POST_FUND_PRODUCT_OFFER_REQUEST_FAIL = `${API_POST_FUND_PRODUCT_OFFER_REQUEST} [fail]`;

export const API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE = `api/GET_DRAW_DOWN_REPAYMENT_SCHEDULE`;
export const API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE_SUCCESS = `${API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE} [success]`;
